import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Flash from 'client/features/flashes/components/Flash.jsx'

class Flashes extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const flashNodes = this.props.flashes.all.map((flash, index) => <Flash flash={ flash } key={ index }/>)
        if (!flashNodes[0]) return <div></div>
        return (
            <div id='flashes-box'>
                { flashNodes }
            </div>
        )
    }
}

Flashes.contextTypes = {
    store: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
    const { flashes } = state
    return {
        flashes
    }
}

export default connect(mapStateToProps)(Flashes)


// WEBPACK FOOTER //
// ./src/client/features/flashes/containers/Flashes.jsx